import * as actions from './actions'
import produce from 'immer'

const initialState = {
  loading: false,
  error: null,
  accountConnectionsSummary: []
}

const accountConnectionsSummaryLoad = draft => {
  draft.loading = true
  draft.error = null
  draft.accountConnectionsSummary = []
}

const accountConnectionsSummaryLoaded = (draft, action) => {
  draft.loading = false
  draft.error = null
  draft.accountConnectionsSummary = action.accountConnectionsSummary
}

const accountConnectionsSummaryLoadFail = (draft, action) => {
  draft.loading = false
  draft.error = action.error
  draft.accountConnectionsSummary = []
}

const reducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case actions.ACC_CONN_SUMMARY_LOAD_SAGA:
        return accountConnectionsSummaryLoad(draft)
      case actions.ACC_CONN_SUMMARY_LOADED:
        return accountConnectionsSummaryLoaded(draft, action)
      case actions.ACC_CONN_SUMMARY_LOAD_FAILURE:
        return accountConnectionsSummaryLoadFail(draft, action)
      default:
        return state
    }
  })
}

export { reducer }
